import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Broker Comparison', path: '/broker-comparison' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="glassmorphism-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="header-logo" className="flex items-center">
            <span className="text-2xl font-bold" style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}>
              dhanamm<span style={{ color: '#FF5722' }}>.com</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-[#FF5722]'
                    : 'text-[#475569] hover:text-[#0A0F1A]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          <Link
            to="/brokerage-plans"
            data-testid="header-cta-button"
            className="hidden lg:block btn-primary"
            style={{
              backgroundColor: '#FF5722',
              color: 'white',
              fontWeight: 600,
              padding: '0.75rem 2rem',
              border: 'none',
              textDecoration: 'none'
            }}
          >
            Open Account
          </Link>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[#E2E8F0]" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  className={`text-sm font-medium py-2 ${
                    isActive(link.path)
                      ? 'text-[#FF5722]'
                      : 'text-[#475569]'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/brokerage-plans"
                data-testid="mobile-cta-button"
                className="btn-primary text-center mt-2"
                style={{
                  backgroundColor: '#FF5722',
                  color: 'white',
                  fontWeight: 600,
                  padding: '0.75rem 2rem',
                  border: 'none',
                  textDecoration: 'none',
                  display: 'block'
                }}
              >
                Open Account
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;